import {Component} from '@angular/core';
import {AlertController, IonicPage, NavController, NavParams} from 'ionic-angular';
import {AuthProvider, AuthResponse} from "../../providers/auth/auth";
import {CrearOrdenPage} from "../crear-orden/crear-orden";
import {Subscription} from "rxjs/Subscription";
import { OrdensPage } from '../ordens/ordens';
import * as moment from "moment"; 

/**
 * Generated class for the LoginPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {

  data = {password: '', email: ''};

  getCredentialsSubscription: Subscription;
  today;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private alertCtrl: AlertController,
              private authProvider: AuthProvider
  ) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad LoginPage');

    this.getCredentialsSubscription = this.authProvider.getCrendentials.subscribe((res) => {
    this.today=Date.now();
    console.log('Token expira: ',res.expires_at);
    console.log('Fecha de Hoy: ',moment(this.today).format("DD MM Y hh:mm"));
      // if (res.accessToken ) {
      if (res.expires_at >= moment(this.today).format("DD MM Y hh:mm")) {
        this.navCtrl.setRoot(OrdensPage)
      }
    })

  }


  login() {

    this.authProvider.makeLogin(this.data)
      .subscribe(
        (res: AuthResponse) => {

          this.getCredentialsSubscription.unsubscribe();

          this.authProvider.saveCredentials(res);

          this.alertCtrl.create({
            title: 'Autenticación correcta!',
            subTitle: `Bienvenido ${res.name} de nuevo`,
            buttons: [
              {
                text: 'Ok',
                handler: () => {
                  this.navCtrl.setRoot(OrdensPage);
                }
              }
            ]
          }).present();
        },
        (err) => {

          this.alertCtrl.create({
            title: 'Error',
            subTitle: 'Ocurrio un error al realizar la autenticación, ' +
            'verifica que los datos sean correctos e intenta de nuevo mas tarde',
            buttons: ['Ok']
          }).present();

          console.log(`err`, err)
        }
      );

  }

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts